import React, { Component } from 'react';
import { JSONTree } from 'react-json-tree';
const styles = {
    actionBar: {
        paddingTop: 8,
        paddingBottom: 7,
        paddingLeft: 16,
    },
    payload: {
        margin: 0,
        paddingLeft: 16,
        overflow: 'auto',
    },
};
export default class LogMonitorAction extends Component {
    constructor() {
        super(...arguments);
        this.shouldExpandNodeInitially = (keyPath, data, level) => {
            return this.props.expandActionRoot && level === 0;
        };
    }
    renderPayload(payload) {
        return (React.createElement("div", { style: {
                ...styles.payload,
                backgroundColor: this.props.theme.base00,
            } }, Object.keys(payload).length > 0 ? (React.createElement(JSONTree, { theme: this.props.theme, invertTheme: false, keyPath: ['action'], data: payload, shouldExpandNodeInitially: this.shouldExpandNodeInitially })) : ('')));
    }
    render() {
        const { type, ...payload } = this.props.action;
        return (React.createElement("div", { style: {
                backgroundColor: this.props.theme.base02,
                color: this.props.theme.base06,
                ...this.props.style,
            } },
            React.createElement("div", { style: styles.actionBar, onClick: this.props.onClick }, type !== null && type.toString()),
            !this.props.collapsed ? this.renderPayload(payload) : ''));
    }
}
